import * as t from "io-ts";
import { isoDateTime } from "./date-time";
import { nullable } from "./index";
export const webSocketDriverLoginEventT = t.strict({
    loggedInAt: isoDateTime,
    routeId: t.string,
    truckId: t.string,
    trailerId: nullable(t.string),
    driverId: t.string,
});
export const webSocketDriverStopCompletedEventT = t.strict({
    stopId: t.string,
    routeId: t.string,
    truckId: t.string,
    driverId: t.string,
    completedAt: isoDateTime,
});
export const webSocketDriverStopArrivedEventT = t.strict({
    stopId: t.string,
    routeId: t.string,
    truckId: t.string,
    driverId: t.string,
    arrivedAt: isoDateTime,
});
export const webSocketDriverStopDepartedEventT = t.strict({
    stopId: t.string,
    routeId: t.string,
    truckId: t.string,
    driverId: t.string,
    departedAt: isoDateTime,
});
//# sourceMappingURL=dispatcher-app-websocket-events.js.map